import CityPageTemplate from "../city-template/CityPageTemplate";
import { covingtonConfig } from "./data";

export default function CovingtonPage() {
  return <CityPageTemplate config={covingtonConfig} />;
}